import {Component, Input} from "@angular/core";

@Component({
    selector: "app-report-holiday-list",
    templateUrl: "./report-holiday-list.component.html",
    styleUrls: ["./report-holiday-list.component.scss"]
})
export class ReportHolidayListComponent {
    @Input() holidayRows: ReportHolidayListRow[] = [];
}

interface ReportHolidayListRow {
    dateLabel: string;
    holidayLabel: string;
    color?: string;
}
